export default __webpack_public_path__ + "3412d8caca3d902ca8fcfebf2ba4dc22.png";